import React, { useState, ChangeEvent, useEffect } from "react";
import { Label } from "@/components/ui/label"; // Adjust based on your component setup
import { Input } from "@/components/ui/input"; // Adjust based on your component setup
import { Image as ImageIcon } from "lucide-react"; // Or your preferred icon lib

type ImageUploaderProps = {
  onImageSelect: (base64: string) => void;
  initialImage?: string | null;
};

const ImageUploader: React.FC<ImageUploaderProps> = ({
  onImageSelect,
  initialImage,
}) => {
  const [preview, setPreview] = useState<string | null>(null);

  useEffect(() => {
    if (initialImage) {
      setPreview(initialImage);
    } else {
      setPreview(null);
    }
  }, [initialImage]);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file || !file.type.startsWith("image/")) {
      alert("Please select a valid image file.");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result as string;
      setPreview(base64String);
      onImageSelect(base64String);
    };
    reader.readAsDataURL(file);
  };

  return (
    <div>
      <Label htmlFor="image">Event Image *</Label>
      <div className="mt-1 flex items-center">
        <Label
          htmlFor="image-upload"
          className="flex items-center justify-center w-full h-32 px-4 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50"
        >
          {preview ? (
            <img
              src={preview}
              alt="Preview"
              className="object-contain h-full w-full rounded-md"
            />
          ) : (
            <div className="space-y-1 text-center">
              <ImageIcon className="mx-auto h-8 w-8 text-gray-400" />
              <div className="text-sm text-gray-600">
                <span className="font-medium text-cecure-700 hover:text-cecure-800">
                  Click to upload
                </span>
                <span> or drag and drop</span>
              </div>
              <p className="text-xs text-gray-500">PNG, JPG, GIF up to 10MB</p>
            </div>
          )}
        </Label>
        <Input
          id="image-upload"
          type="file"
          className="hidden"
          accept="image/*"
          onChange={handleFileChange}
        />
      </div>
    </div>
  );
};

export default ImageUploader;
